import {createSvgIcon} from "@mui/material";

const ChevronUpIcon = createSvgIcon(
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M5 12.5L10 7.5L15 12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>,
	'ChevronUp',
)

export default ChevronUpIcon
